module.exports = __webpack_public_path__ + "assets/bpmn.1381b44e.svg";